import * as actionTypes from './actionTypes';

export const fetchDefaultFavorites = dashboardId => ({
  type: actionTypes.FETCH,
  dashboardId,
});
export const fetchDefaultFavoritesSuccess = ids => ({
  type: actionTypes.FETCH_SUCCESS,
  ids,
});
export const fetchDefaultFavoritesError = error => ({
  type: actionTypes.FETCH_ERROR,
  error,
});

export const fetchDashboardsWithFavoriteDocument = (entityType, entityId) => ({
  type: actionTypes.FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE,
  entityType,
  entityId,
});
export const fetchDashboardsWithFavoriteDocumentSuccess = ids => ({
  type: actionTypes.FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE_SUCCESS,
  ids,
});
export const fetchDashboardsWithFavoriteDocumentError = error => ({
  type: actionTypes.FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE_ERROR,
  error,
});

export const addDefaultFavorite = (dashboardId, entityType, entityId) => ({
  type: actionTypes.ADD_FAVORITE,
  dashboardId,
  entityType,
  entityId,
});
export const addDefaultFavoriteSuccess = id => ({
  type: actionTypes.ADD_FAVORITE_SUCCESS,
  id,
});
export const addDefaultFavoriteError = error => ({
  type: actionTypes.ADD_FAVORITE_ERROR,
  error,
});

export const removeDefaultFavorite = (dashboardId, entityType, entityId) => ({
  type: actionTypes.REMOVE_FAVORITE,
  dashboardId,
  entityType,
  entityId,
});
export const removeDefaultFavoriteSuccess = id => ({
  type: actionTypes.REMOVE_FAVORITE_SUCCESS,
  id,
});
export const removeDefaultFavoriteError = error => ({
  type: actionTypes.REMOVE_FAVORITE_ERROR,
  error,
});
